"use client";

import { usePathname } from "next/navigation";

interface AuthPromptModalProps {
  onDismiss: () => void;
}

export function AuthPromptModal({ onDismiss }: AuthPromptModalProps) {
  const pathname = usePathname();
  const loginHref = `/login?redirect_to=${encodeURIComponent(pathname)}`;
  const signupHref = `/signup?redirect_to=${encodeURIComponent(pathname)}`;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        backdropFilter: "blur(6px)",
      }}
      onClick={onDismiss}
    >
      <div
        style={{
          background: "var(--paper-2)",
          border: "1px solid var(--line-strong)",
          borderRadius: "16px",
          padding: "40px 32px",
          maxWidth: "420px",
          width: "100%",
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: "40px", marginBottom: "16px" }} aria-hidden="true">
          🔒
        </div>
        <h3 style={{ margin: "0 0 8px", fontSize: "20px", fontWeight: 600, color: "var(--ink)" }}>
          Sign in to continue
        </h3>
        <p style={{ margin: "0 0 24px", color: "var(--ink-soft)", fontSize: "14px", lineHeight: 1.5 }}>
          Create a free account to generate drafts, save your work, and access all features.
        </p>
        <a
          href={loginHref}
          style={{
            display: "inline-block",
            padding: "12px 28px",
            background: "#5B6CFF",
            borderRadius: "10px",
            color: "#fff",
            fontWeight: 600,
            textDecoration: "none",
            fontSize: "14px",
          }}
        >
          Sign in
        </a>
        <div style={{ marginTop: "12px" }}>
          <a
            href={signupHref}
            style={{
              color: "#5B6CFF",
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            Start for free
          </a>
        </div>
        <button
          onClick={onDismiss}
          style={{
            display: "block",
            margin: "16px auto 0",
            background: "none",
            border: "none",
            color: "var(--ink-mute)",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
